import React, { useState, useEffect } from "react";
import Web3 from "web3";
import { loadWeb3 } from "./Web3/Api";
import { nftAdress, nftAbi } from "../../contract/contract";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Collection from "../Collection/Collection";
import Frequently from "../Frequently/Frequently ";
import Join from "../Join/Join";
import Footer from "../Footer/Footer";
import NftTransferModel from "../../Model/NftTransferModel";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Home.css";

const steps = [
  { label: "Connect your wallet" },
  { label: "Fund your wallet with SBG tokens" },
  { label: "Select the number of NFTs to mint" },
  { label: "Mint your NFTs and view them on the MYNFT page" },
];

const Home = ({ address, connect, renderWalletAddress }) => {
  const web3 = new Web3(window.ethereum);
  const [counter, setCounter] = useState(1);
  const [nftContract, setNftContract] = useState(null);
  const [mintingPrice, setMintingPrice] = useState(0);
  const [userBalance, setUserBalance] = useState(0);
  const [totalSupply, setTotalSupply] = useState(0);

  const fetchTotalSupply = async (contract) => {
    try {
      const supply = await contract.methods.totalSupply().call();
      setTotalSupply(supply);
    } catch (error) {
      console.error("Error fetching total supply:", error);
    }
  };

  const integrateNftContract = () => {
    const mintingContract = new web3.eth.Contract(nftAbi, nftAdress);
    return mintingContract;
  };

  useEffect(() => {
    const init = async () => {
      if (window.ethereum && address) {
        try {
          const contract = integrateNftContract();
          setNftContract(contract);
          fetchTotalSupply(contract);
        } catch (error) {
          console.error("Error initializing web3 or contracts:", error);
        }
      }
    };

    init();
  }, [address]);

  const incCounter = () => {
    if (counter < 100) {
      setCounter(counter + 1);
    }
  };

  const decCounter = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };

  const handleMint = async () => {
    try {
      await loadWeb3();

      const Nftcontract = integrateNftContract();
      setNftContract(Nftcontract);

      const balance = await web3.eth.getBalance(address);
      setUserBalance(balance);

      const mintPrice = await Nftcontract.methods.PRICE_PER_NFT().call();
      setMintingPrice(mintPrice);

      const mintAmount = counter;
      const tokenCostPerNFT = web3.utils.toBN(mintPrice);
      const totalTokenCost = tokenCostPerNFT.mul(web3.utils.toBN(mintAmount));

      if (web3.utils.toBN(balance).lt(totalTokenCost)) {
        toast.error("Insufficient SGB balance.");
        return;
      }

      await Nftcontract.methods.mintPublic(mintAmount.toString()).send({
        from: address,
        value: totalTokenCost.toString(),
      });

      toast.success("NFTs minted successfully!");
      fetchTotalSupply(Nftcontract);
    } catch (error) {
      console.error("Error minting NFTs:", error);
      toast.error("An error occurred while minting NFTs. Please try again.");
    }
  };

  return (
    <div className="bgHomeColor py-4">
      <ToastContainer />
      <div className="bgNftImg">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-lg-7">
              <div className="row justify-content-center pt-5">
                <div className="col-10 col-md-8 col-lg-6 card-bg p-4 text-center">
                  <h5 className="fw-bold color">MINT YOUR NFT</h5>
                  <p className="color">Price Per NFT 1000 SBG</p>
                  <h1 className="text-white fw-bolder mt-5 ">{totalSupply}/10,000</h1>
                  <div className="d-flex justify-content-center align-items-center">
                    <button className="card-btn" onClick={decCounter}>
                      -
                    </button>
                    <input
                      type="text"
                      value={counter}
                      className="input-field p-2 mx-3 text-center fw-bold "
                      readOnly
                    />
                    <button className="card-btn" onClick={incCounter}>
                      +
                    </button>
                  </div>
                  <p className="pt-2 lh-sm mb-0 color"></p>
                  <br />
                  <p className="lh-sm color"></p>
                  <div className="button-width">
                    <div className="d-flex justify-content-evenly">
                      <button className="homeCardBtn" onClick={handleMint}>
                        MINT
                      </button>
                      <Link to="/myNft">
                        <button className="homeCardBtn">MY NFT</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-10 col-lg-4 pt-5 pr-5">
              <div className="">
                <div className="">
                  <h4 className="fw-bold pb-5 coloor">
                  How to Mint your Marthy NFT
                  </h4>
                </div>
                <div className="">
                  <Box sx={{ maxWidth: 400 }}>
                    <Stepper orientation="vertical">
                      {steps.map((step, index) => (
                        <Step
                          key={step.label}
                          sx={{
                            "& .MuiStepLabel-root .Mui-completed": {
                              color: "",
                            },
                            "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": {
                              color: "",
                            },
                            "& .MuiStepLabel-root .Mui-active": {
                              color: "rgb(0 0 0 / 38%)",
                            },
                            "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
                              color: "",
                            },
                            "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                              fill: "white",
                            },
                          }}
                        >
                          <StepLabel
                            sx={{
                              color: "white",
                            }}
                            optional={
                              index === 2 ? (
                                <Typography variant="caption"></Typography>
                              ) : null
                            }
                          >
                            {step.label}
                          </StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Collection />
      {/* <Frequently /> */}
      <Join />
      <Footer />
      <NftTransferModel
        address={address}
        connect={connect}
        renderWalletAddress={renderWalletAddress}
      />
    </div>
  );
};

export default Home;
